import { merge } from 'lodash'

/**
 * @param {Mirage.Server} server the mirage server.
 * @param {String|Number} teacherId the id of the mirage teacher model instance.
 * @param {Object} attributes for setting subscription-utilisation attributes
 * @returns {Object} the mirage model 'subscription-utilisation' instance
 */
export function createOrUpdateTeacherSubscriptionUtilisation(server, teacherId, attributes = {}) {
  const hash = { licenceCount: 100, remainingLicences: 100, studentCount: 0, subscriptionType: null, ...attributes }

  if (!hash.subscriptionType) throw new Error('Expected hash.subscriptionType to have a value')
  const teacherSubscription = server.db.teacherSubscriptions.findBy({
    subscriptionType: hash.subscriptionType,
    teacherId,
  })
  if (!teacherSubscription) throw new Error(`Expected teacher:${teacherId} to have teacher-subscription`)
  const { subscriptionUtilisationId } = teacherSubscription
  const subscriptionUtilisation = server.schema.subscriptionUtilisations.findBy({ id: subscriptionUtilisationId })
  if (!subscriptionUtilisationId || !subscriptionUtilisation) {
    const teacherSubscriptionId = teacherSubscription.id
    return server.create('subscription-utilisation', { ...hash, teacherSubscriptionId })
  } else {
    subscriptionUtilisation.update(hash)
    subscriptionUtilisation.save()
    return subscriptionUtilisation
  }
}

/**
 * @param {Mirage.Server} server the mirage server.
 * @param {String|Number} schoolId the id of the mirage school model instance.
 * @param {Object} attributes for setting subscription-utilisation attributes
 * @returns {Object} the mirage model 'subscription-utilisation' instance
 */
export function createOrUpdateSchoolSubscriptionUtilisation(server, schoolId, attributes = {}) {
  const hash = { licenceCount: 100, remainingLicences: 100, studentCount: 0, subscriptionType: null, ...attributes }

  if (!hash.subscriptionType) throw new Error('Expected hash.subscriptionType to have a value')

  // Find relevant school subscription
  const schoolSubscription = server.db.schoolSubscriptions.findBy({
    subscriptionType: hash.subscriptionType,
    schoolId,
  })
  if (!schoolSubscription) throw new Error(`Expected school:${schoolId} to have school-subscription`)

  // Use the above subscription to create or update a related utilisation record
  const { subscriptionUtilisationId } = schoolSubscription
  const subscriptionUtilisation = server.schema.subscriptionUtilisations.findBy({ id: subscriptionUtilisationId })
  if (!subscriptionUtilisationId || !subscriptionUtilisation) {
    const subscriptionUtilisationHash = merge(hash, { schoolSubscriptionId: schoolSubscription.id })
    return server.create('subscription-utilisation', subscriptionUtilisationHash)
  } else {
    subscriptionUtilisation.update(hash)
    subscriptionUtilisation.save()
    return subscriptionUtilisation
  }
}
